export const getUser = (state) => state?.profile?.user || {};
